// remove array item
Array.prototype.remove_array_item = function() {
    let what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

// insert to product toast html
function insert_to_product_toast(html){
    $('#product-toast .toast-body').html(html);
}

// get top position for sticky elements without header and adminbar heights
function get_offset_top(){
    let header = $('#header').outerHeight();
    let topToScroll = header + ($('body').is('.admin-bar') ? 32 : 0);

    $('.js-offset-top').css('top', topToScroll);
}